export default __webpack_public_path__ + "static/media/HamburgerMenuIcon.3ece9762.svg";